import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import React from "react";
import { updateSubscription } from "../../../../../services/subscriptions.service";
import { useToast } from "../../../../../ui-components/ToastProvider";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
  adminModalSx,
} from "../../../modalStyle";

interface PreSubscription {
  id: number;
  user_id: number;
  event_id: number;
  first_time: boolean;
  start_date: Date;
  end_date: Date;
  status_id: number;
  created_at: Date;
  is_paid: boolean;
  event_space: number;
}

export default function UpdateButton({
  id,
  updateSubscriptions,
  sub,
}: {
  id: number;
  updateSubscriptions: Function;
  sub: PreSubscription;
}) {
  const [open, setOpen] = React.useState(false);
  const { showToast } = useToast();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const formData: any = Object.fromEntries(new FormData(e.target).entries());
    formData.is_paid = formData.is_paid === "true";
    formData.status_id = parseInt(formData.status_id);
    updateSubscription(formData, id).then(() => {
      showToast("Alterado com sucesso!", { severity: "success" });
      updateSubscriptions();
    }).catch(() => {
      showToast("Erro ao atualizar inscrição!", { severity: "error" });
    });
    handleClose();
  };

  return (
    <>
      <ModalComponent open={open} handleClose={handleClose} title="Editando as informações da Inscrição" autoHeight>
          <form onSubmit={handleSubmit}>
            <Box sx={{ p: 0, display: "flex", flexDirection: "column", gap: 3 }}>
              <FormControl size="small">
                <InputLabel id="is-paid-label">Pagamento efetuado</InputLabel>
                <Select
                  labelId="is-paid-label"
                  name="is_paid"
                  label="Pagamento efetuado"
                  defaultValue={sub.is_paid.toString()}
                >
                  <MenuItem value={"true"}>Sim</MenuItem>
                  <MenuItem value={"false"}>Não</MenuItem>
                </Select>
              </FormControl>

              <FormControl size="small">
                <InputLabel id="status-label">Status da Inscrição</InputLabel>
                <Select
                  labelId="status-label"
                  name="status_id"
                  label="Status da Inscrição"
                  defaultValue={sub.status_id}
                >
                  <MenuItem value={0}>Em Análise</MenuItem>
                  <MenuItem value={1}>Aceito</MenuItem>
                  <MenuItem value={2}>Recusado</MenuItem>
                </Select>
              </FormControl>

              <TextField
                name="event_space"
                type="number"
                label="Posição no Croqui"
                defaultValue={sub.event_space}
                size="small"
              />

              <Box
                sx={{
                  pt: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row-reverse",
                  justifyContent: isMobile ? "flex-end" : "flex-start",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  sx={adminButtonPrimarySx}
                  fullWidth={isMobile}
                >
                  Alterar
                </Button>
                <Button
                  onClick={handleClose}
                  sx={adminButtonOutlinedSx}
                  fullWidth={isMobile}
                >
                  Cancelar
                </Button>
              </Box>
            </Box>
          </form>
      </ModalComponent>
      <IconButton
        onClick={() => {
          handleOpen();
          updateSubscriptions();
        }}
      >
        <EditIcon />
      </IconButton>
    </>
  );
}
